import React from "react";
import { Link } from "../../lib/Link";

export const lineup = type => {
  return (
    <div className="lineup">
      <div className="sp">
        <div className="message">
          <div className="title">商品ラインナップ</div>
          <div>商品タイプの概要をご説明</div>
        </div>
        <div className="content">
          <div className="item">
            <div className="image inside" />
            <div className="title">屋内型トランクルーム</div>
            <div className="infomation">
              ２４時間利用可能な屋内型の格納スペースです。首都圏を中心に約17,000室と最大級の取り揃え！
            </div>
          </div>
          <div className="item">
            <div className="image outside" />
            <div className="title">屋外型トランクルーム</div>
            <div className="infomation">
              海上運送用の丈夫なコンテナを利用した大型収納スペースです。車乗り入れ可で、入出庫がとてもスムーズ！
            </div>
          </div>
          <div className="item">
            <div className="image premium" />
            <div className="title">トランクハウス24</div>
            <div className="infomation">
              トランクルーム専用に設計した1軒家型の屋内収納スペースです。広すぎない、無駄をなくしたスマート設計！
            </div>
          </div>
          <div className="item">
            <div className="image motorbike" />
            <div className="title">バイク専用トランクルーム</div>
            <div className="infomation">
              BOX型、屋外型、室内型と複数のタイプをご用意したバイク専用の収納スペースです。愛車を大切にしたい方に！
            </div>
          </div>
        </div>
        <Link to="/lineup/" className="btn center black">
          一覧を見る
        </Link>
      </div>
      <div className="pc">
        <div className="message">
          <div className="title">商品ラインナップ</div>
          <div>商品タイプの概要をご説明</div>
        </div>
        <Link to="/lineup/" className="btn center black">
          一覧を見る
        </Link>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/top/lineup.jsx